'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Chart = require('./Chart.css');

var _Chart2 = _interopRequireDefault(_Chart);

var _reactChartjs = require('react-chartjs');

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import format from '../../helpers/format'

var Chart = (_dec = (0, _reactCssModules2.default)(_Chart2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);
    return (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var colorDict = {
        'percentile-null': '#E1E1E1',
        'percentile-10': '#eb1c24',
        'percentile-20': '#f54929',
        'percentile-30': '#fe7328',
        'percentile-40': '#ff981d',
        'percentile-50': '#febb0a',
        'percentile-60': '#ffd301',
        'percentile-70': '#cfcf0d',
        'percentile-80': '#88c424',
        'percentile-90': '#3cb33f',
        'percentile-100': '#01a652'
      };

      var _props = this.props,
          gefScore = _props.gefScore,
          gefStyle = _props.gefStyle,
          type = _props.type;


      var isLarge = type === 'large';
      var isUnscored = gefScore === '-1';

      var size = isLarge ? 200 : 100;
      var circleSize = isLarge ? 85 : 70;

      var unscoredChartDate = [{
        value: 100,
        color: '#E1E1E1'
      }];

      var scoredChartData = [{
        value: gefScore,
        color: colorDict[gefStyle]
      }, {
        value: 100 - gefScore,
        color: '#E1E1E1'
      }];

      var chartOptions = {
        animation: !isUnscored,
        segmentStrokeWidth: 0,
        percentageInnerCutout: circleSize,
        animationEasing: 'easeOutQuad',
        showTooltips: false
      };

      var chartData = isUnscored ? unscoredChartDate : scoredChartData;
      var label = isUnscored ? 'Unscored' : '/ 100 points';

      return _react2.default.createElement(
        'div',
        { styleName: 'chart' },
        _react2.default.createElement(_reactChartjs.Doughnut, {
          data: chartData,
          options: chartOptions,
          width: size,
          height: size
        }),
        isLarge ? _react2.default.createElement(
          'div',
          { styleName: 'chart-details' },
          isUnscored ? _react2.default.createElement(
            'div',
            { styleName: 'chart-ban' },
            _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-ban' })
          ) : _react2.default.createElement(
            'div',
            { styleName: 'chart-assets' },
            gefScore
          ),
          _react2.default.createElement(
            'div',
            null,
            label
          )
        ) : null
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  gefScore: _react.PropTypes.string,
  gefStyle: _react.PropTypes.string,
  type: _react.PropTypes.string
}, _temp)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1288
// module chunks = 0